import { createResource, For, onCleanup, Show } from 'solid-js'
import { api } from '../api/client.ts'
import { createProject, deleteProject, openProject, flushCurrent, project } from '../project.ts'
import { Icon } from './Icon.tsx'

function Thumbnail(props: { id: string }) {
  const [url] = createResource(
    () => props.id,
    async (id) => {
      const blob = await api.thumbnail(id)
      return blob ? URL.createObjectURL(blob) : ''
    },
  )
  onCleanup(() => {
    const u = url()
    if (u) URL.revokeObjectURL(u)
  })
  return <img class="thumb" src={url() ?? ''} alt="" />
}

export function ProjectPicker(props: { onClose: () => void }) {
  const [projects, { refetch }] = createResource(async () => {
    // Flush the open project first so its thumbnail and name are current here.
    await flushCurrent()
    return api.listProjects()
  })

  const open = async (id: string) => {
    await openProject(id)
    props.onClose()
  }

  const create = async () => {
    await createProject()
    props.onClose()
  }

  const remove = async (id: string, name: string) => {
    if (!confirm(`Delete "${name}"? This cannot be undone.`)) return
    await deleteProject(id)
    void refetch()
  }

  return (
    <div class="modal-backdrop" onClick={props.onClose}>
      <div class="modal" onClick={(e) => e.stopPropagation()}>
        <div class="modal-head">
          <h2>Projects</h2>
          <button type="button" class="btn" onClick={() => void create()}>
            <Icon name="plus" size={16} />
            New
          </button>
        </div>

        <Show when={!projects.loading} fallback={<p class="muted">Loading…</p>}>
          <Show
            when={(projects()?.length ?? 0) > 0}
            fallback={<p class="muted">No projects yet.</p>}
          >
            <ul class="project-grid">
              <For each={projects()}>
                {(p) => (
                  <li classList={{ current: project()?.id === p.id }}>
                    <button type="button" class="project-card" onClick={() => void open(p.id)}>
                      <Show
                        when={p.hasThumbnail}
                        fallback={<div class="thumb placeholder" />}
                      >
                        <Thumbnail id={p.id} />
                      </Show>
                      <span class="project-card-name">{p.name}</span>
                      <span class="muted">{new Date(p.updatedAt).toLocaleString()}</span>
                    </button>
                    <button
                      type="button"
                      class="btn icon-only danger"
                      title="Delete project"
                      onClick={() => void remove(p.id, p.name)}
                    >
                      <Icon name="trash" size={15} />
                    </button>
                  </li>
                )}
              </For>
            </ul>
          </Show>
        </Show>

        <div class="modal-foot">
          <button type="button" class="btn" onClick={props.onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
